import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f438c516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-0 m-0" }
const _hoisted_2 = { class: "py-4 pl-4" }
const _hoisted_3 = { class: "content-wrapper" }
const _hoisted_4 = { class: "text-md font-light" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "flex flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_CloudOfflineIcon = _resolveComponent("CloudOfflineIcon")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, {
    button: "true",
    class: "rounded-sm bg-white acon-card-shadow",
    "data-cy": "property-list-item",
    onClick: _ctx.cardClicked,
    onMouseover: _ctx.hover
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "p-0 m-0 flex flex-row",
          style: _normalizeStyle(_ctx.isSlideMode ? 'h-40' : 'h-36')
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_image, {
              "image-class": `w-28 h-28 md:h-32 object-cover p-0 m-0`,
              src: _ctx.getPhotoUrl(_ctx.property.vorschaubild, { small: true }),
              "set-to-max": ""
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ion_card_header, { class: "flex-1 text-left" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_title, { class: "text-lg leading-5 md:text-xl mb-3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.property.externeObjektNr), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.property.strasse), 1),
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(_ctx.property.plz) + " " + _toDisplayString(_ctx.property.stadt), 1)
                ]),
                _createVNode(_component_ion_card_subtitle, { class: "text-md" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.baLabels, (label) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: label,
                          class: "inline-flex items-center mr-2.5 px-2 py-1 rounded-full text-xs border border-solid border-blue-600 text-blue-600 mt-2",
                          style: {"word-break":"break-word"}
                        }, _toDisplayString(label), 1))
                      }), 128)),
                      (_ctx.property.isDownloaded)
                        ? (_openBlock(), _createBlock(_component_CloudOfflineIcon, {
                            key: 0,
                            small: "",
                            class: "mt-2"
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ], 4),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ]),
    _: 3
  }, 8, ["onClick", "onMouseover"]))
}